module.exports = __webpack_public_path__ + "img/partner.30d378cb.png";